var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.error)?_c('div',{staticClass:"notification is-danger is-light"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e(),_c('router-link',{staticClass:"button is-info",attrs:{"to":{ name: 'home' }}},[_vm._v("Back to homepage")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }